import { render, staticRenderFns } from "./InvoiceMessage.vue?vue&type=template&id=a1584b0c&scoped=true&"
import script from "./InvoiceMessage.vue?vue&type=script&lang=js&"
export * from "./InvoiceMessage.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceMessage.vue?vue&type=style&index=0&id=a1584b0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1584b0c",
  null
  
)

export default component.exports